import axios from 'axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async callAutoCorrect({ commit }) {
      try {
        await axios.post(`${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/auto-correct`);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
